import { ArrowForward } from '@material-ui/icons';
import { Form, Input, Button, Pagination, Tooltip } from 'antd';
import Loading from 'components/Basic/Loading';
import toast from 'components/Basic/Toast';
import ContentHeader from 'containers/Dashboard/ContentHeader';
import * as dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import UserIsNotFoundModal from 'components/Basic/UserIsNotFoundModal';
import moment from 'moment-timezone';
import {
  useLazyGetCustomerPhoneHistotyQuery,
  useUpdateCustomerPhoneStatusMutation,
} from 'core/customer/CustomerService';

dayjs.extend(utc);
dayjs.extend(timezone);

const UserManagePhone = ({ match }) => {
  const intl = useIntl();
  const [state, setState] = useState({
    phoneForCheck: '',
    reasonOfStatusChanged: '',
  });
  const [isOpenTable, setOpenTable] = useState(false);
  const [isShowUserIsNotFoundModal, setShowUserIsNotFoundModal] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getUserPhoneHistory] = useLazyGetCustomerPhoneHistotyQuery();
  const [updateCustomerPhoneStatus] = useUpdateCustomerPhoneStatusMutation();

  const handleChangePage = (page, size) => {
    setCurrent(page);
    setPageSize(size);
    onChangePage((page - 1) * size, size);
  };

  const onChangePage = async (page, size) => {
    setIsLoading(true);
    try {
      /*const queryString = buildQueryString({
        phone: state.phoneForCheck,
        page: page,
        size: size,
        count: true,
      });*/
      const userData = await getUserPhoneHistory(encodeURIComponent(`+${state.phoneForCheck}`)).unwrap();
      if (!userData.length) {
        setShowUserIsNotFoundModal(true);
        setIsLoading(false);
        return;
      }
      setUserData(userData);
      setTotal(userData.length);
      setIsLoading(false);
    } catch (e) {
      setOpenTable(false);
      setIsLoading(false);
      setShowUserIsNotFoundModal(true);
    }
  };

  const handleShowSizeChange = (c, s) => {
    handleChangePage(1, s);
  };

  const handleReasonChange = value => {
    setState(prev => ({ ...prev, reasonOfStatusChanged: value.trim().length === 0 ? '' : value.replace(/\s+/g, ' ') }));
  };

  const handlePhoneChange = value => {
    setState(prev => ({ ...prev, phoneForCheck: value }));
  };

  const handlePhoneCheck = async () => {
    try {
      setOpenTable(false);
      setIsLoading(true);
      setState(prev => ({ ...prev, reasonOfStatusChanged: '' }));
      /*const queryString = buildQueryString({
        phone: state.phoneForCheck,
        page: page,
        size: size,
        count: true,
      });*/
      const userData = await getUserPhoneHistory(encodeURIComponent(`+${state.phoneForCheck}`)).unwrap();
      if (!userData.length) {
        setShowUserIsNotFoundModal(true);
        setIsLoading(false);
        return;
      }
      setUserData(userData);
      setTotal(userData.length);
      setOpenTable(true);
      setIsLoading(false);
    } catch {
      setIsLoading(false);
      setShowUserIsNotFoundModal(true);
    }
  };

  const makePhoneAvaliable = async () => {
    try {
      await updateCustomerPhoneStatus({
        phone: `+${state.phoneForCheck}`,
        description: state.reasonOfStatusChanged.trim(),
      }).unwrap();
      setState(prev => ({ ...prev, reasonOfStatusChanged: '' }));
      onChangePage(0, 10); //page, size
    } catch {
      toast.error({
        title: intl.formatMessage({
          id: 'Update customer phone status is failure!',
        }),
      });
    }
  };

  return (
    <>
      <div className="user_manage_layout">
        <ContentHeader type="user_manage_phone" />
        <div className="user_manage_phone_wrapper">
          <div className="user_manage_phone_wrapper_border" />
          <div className="content_wrapper">
            <Form>
              <Form.Item>
                <p className="title">
                  <FormattedMessage id="Phone number" />
                </p>
                <div className="phone_wrapper">
                  <ReactPhoneInput
                    country={`${process.env.REACT_APP_COUNTRY || 'gt'}`}
                    value={state.phoneForCheck || ''}
                    onChange={handlePhoneChange}
                  />
                </div>
              </Form.Item>
            </Form>
            <div className="check_btn_wrapper">
              <Button onClick={handlePhoneCheck}>
                <FormattedMessage id="Check number" />
                <ArrowForward />
              </Button>
            </div>
          </div>
          {isOpenTable && (
            <>
              <div className="content_wrapper" style={{ marginTop: '0px' }}>
                <Form>
                  <Form.Item>
                    <p className="title">
                      <FormattedMessage id="Reason" />
                    </p>
                    <Input
                      placeholder={intl.formatMessage({ id: 'Enter the reason of status changed' })}
                      value={state.reasonOfStatusChanged || ''}
                      maxLength={200}
                      onChange={e => handleReasonChange(e.target.value)}
                    />
                  </Form.Item>
                </Form>
                <div className="check_btn_wrapper">
                  <Button disabled={!state.reasonOfStatusChanged} onClick={makePhoneAvaliable}>
                    <FormattedMessage id="Make phone number available for verification" />
                    <ArrowForward />
                  </Button>
                </div>
              </div>
              <div className="user_manage_table_layout">
                <div className="user_manage_table_header">
                  <div className="numberStatus">
                    <FormattedMessage id="Phone number status" />
                  </div>
                  <div className="changedBy">
                    <FormattedMessage id="Status changed by" />
                  </div>
                  <div className="reason">
                    <FormattedMessage id="Reason of status changed" />
                  </div>
                  <div className="receivedAt">
                    <FormattedMessage id="Date and time of status received" />
                  </div>
                  <div className="userIdManage">
                    <FormattedMessage id="Client ID" />
                  </div>
                </div>
                <div className="table_content">
                  {userData &&
                    userData.map((item, index) => (
                      <div className="user_manage_table_item" key={index}>
                        <div className="numberStatus">
                          <div className={`status_wrapper status_${item.newStatus?.match(/^\w+/)[0]}`}>
                            <p>
                              <FormattedMessage id={item.newStatus} />
                            </p>
                          </div>
                        </div>
                        <div className="changedBy">
                          <p>
                            {item.adminId ? (
                              <>
                                <FormattedMessage id={'Admin ID'} /> {` ${item.adminId}`}
                              </>
                            ) : (
                              <>
                                <FormattedMessage id={'Customer ID'} /> {` ${item.customerId}`}
                              </>
                            )}
                          </p>
                        </div>
                        <div className="reason">
                          <p>
                            <FormattedMessage id={item.description} />
                          </p>
                        </div>
                        <div className="receivedAt">
                          <p>
                            {item.createdAt
                              ? `${moment(item.createdAt).tz('America/Guatemala').format('LL')} 
                                    @ ${moment(item.createdAt).tz('America/Guatemala').format('HH:mm')}`
                              : ''}
                          </p>
                        </div>
                        <div className="userIdManage">{item.customerId ? <p>{`ID ${item.customerId}`}</p> : <></>}</div>
                      </div>
                    ))}
                </div>
                {/*<div className="pagination_wrapper">
                  <Pagination
                    showSizeChanger
                    defaultCurrent={1}
                    defaultPageSize={10}
                    current={current}
                    pageSize={pageSize}
                    pageSizeOptions={['5', '10', '20', '30']}
                    total={total}
                    onChange={handleChangePage}
                    onShowSizeChange={handleShowSizeChange}
                  />
                  <div className="total">Resultados: {total}</div>
                </div>*/}
              </div>
            </>
          )}
        </div>
      </div>
      <UserIsNotFoundModal isOpenModal={isShowUserIsNotFoundModal} onClose={() => setShowUserIsNotFoundModal(false)} />
      <Loading visible={isLoading} />
    </>
  );
};

export default UserManagePhone;
